module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp12_3.fb2a5245.png";